/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceNowIncidentManagementCustomEndpoint {
    getFixupPrototypeFunction() { return ServiceNowIncidentManagementCustomEndpoint.fixupPrototype; }

    static newInstance(model: Partial<ServiceNowIncidentManagementCustomEndpoint>): ServiceNowIncidentManagementCustomEndpoint {
        let obj = Object.assign(new ServiceNowIncidentManagementCustomEndpoint(), model);
        ServiceNowIncidentManagementCustomEndpoint.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceNowIncidentManagementCustomEndpoint>): ServiceNowIncidentManagementCustomEndpoint {
        if (!model) return null;
        return ServiceNowIncidentManagementCustomEndpoint.newInstance(<ServiceNowIncidentManagementCustomEndpoint> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceNowIncidentManagementCustomEndpoint) {
        if (!obj) return;

        models.ServiceNowIncidentManagementCustomEndpoint.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceNowIncidentManagementCustomEndpoint): boolean {
        Object.setPrototypeOf(obj, ServiceNowIncidentManagementCustomEndpoint.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Custom endpoint URL for Incident management
     */
    url: string;

    /**
     * Username for Custom Endpoint URL
     */
    username: string;

    /**
     * Password for Custom Endpoint URL
     */
    password: string;

}
